var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.goTopShow,
          expression: "goTopShow",
        },
      ],
      staticClass: "goTop",
      attrs: { id: "goTop" },
      on: { click: _vm.goTop },
    },
    [
      _c("img", {
        attrs: { src: require("@/assets/img/icon/top.png"), alt: "" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }